import { h, Component } from "preact";
import { Field } from "redux-form";
import AdditionalQuestion from "./additionalQuestion/AdditionalQuestion";
import CheckboxField from "../../components/fields/CheckboxField";

class TicketInfo extends Component {
  constructor() {
    super();
    this.toggleSameAsBuyer = this.toggleSameAsBuyer.bind(this);
  }

  componentDidUpdate(previousProps) {
    const lastBuyerInfo = previousProps.buyerData;
    const { buyerData, sameAsBuyerChecks, ticket } = this.props;
    const sameAsBuyer =
      sameAsBuyerChecks && sameAsBuyerChecks[ticket._id]
        ? sameAsBuyerChecks[ticket._id]
        : false;
    if (
      sameAsBuyer &&
      JSON.stringify(buyerData) !== JSON.stringify(lastBuyerInfo)
    ) {
      this.toggleSameAsBuyer(null, true);
    }
  }

  toggleSameAsBuyer(evt, value) {
    const { questions, buyerData, changeFieldValue, ticket } = this.props;
    questions.forEach(q => {
      const fieldName = `tickets.${ticket._id}.${q._id}`;
      if (!value || !buyerData) {
        return;
      }
      switch (q.type) {
        case "firstName":
          changeFieldValue(fieldName, buyerData.firstName);
          break;
        case "lastName":
          changeFieldValue(fieldName, buyerData.lastName);
          break;
        case "mobile":
          changeFieldValue(fieldName, buyerData.mobile);
          break;
        case "email":
          changeFieldValue(fieldName, buyerData.email);
          break;
      }
    });
  }

  render() {
    const {
      ticket,
      questions,
      ticketsAdditionalQuestions,
      sameAsBuyerChecks,
      formName,
      changeFieldValue,
      hideTitles,
      onChange
    } = this.props;
    const style = {
      marginBottom: hideTitles ? 0 : 36
    };
    const askSameAsBuyer = questions.reduce((fieldMatch, q) => {
      if (
        q.type === "firstName" ||
        q.type === "lastName" ||
        q.type === "mobile" ||
        q.type === "email"
      ) {
        fieldMatch = true;
      }
      return fieldMatch;
    }, false);
    const sameAsBuyer =
      sameAsBuyerChecks && sameAsBuyerChecks[ticket._id]
        ? sameAsBuyerChecks[ticket._id]
        : false;

    return (
      <div style={style}>
        {!hideTitles ? (
          <h4 style={{ borderBottom: "1px solid #eeeeee", paddingBottom: 8 }}>
            {ticket.label}
          </h4>
        ) : null}
        {askSameAsBuyer ? (
          <Field
            label="Use the same ticket information as buyer"
            type="checkbox"
            name={`sameAsBuyerChecks.${ticket._id}`}
            onChange={this.toggleSameAsBuyer}
            component={CheckboxField}
          />
        ) : (
          false
        )}
        {questions.map(question => {
          const disabled =
            sameAsBuyer &&
            (question.type === "firstName" ||
              question.type === "lastName" ||
              question.type === "mobile" ||
              question.type === "email")
              ? true
              : false;
          question.name = `tickets.${ticket._id}.${question._id}`;
          return (
            <AdditionalQuestion
              question={question}
              ticketId={ticket._id}
              ticketAdditionalFields={ticket.additionalFields}
              ticketsAdditionalQuestions={ticketsAdditionalQuestions}
              formName={formName}
              disabled={disabled}
              changeFieldValue={changeFieldValue}
              onChange={onChange}
            />
          );
        })}
      </div>
    );
  }
}

export default TicketInfo;



// WEBPACK FOOTER //
// ./routes/details/TicketInfo.js